// extracted by mini-css-extract-plugin
var _1 = "JwkuBONz5H";
export { _1 as "report" }
